<template>
  <header
    class="tw-mt-3 tw-container tw-mx-auto"
  >
    <div class="tw-flex tw-justify-between tw-flex-col sm:tw-flex-row tw-tracking-normal">
      <router-link
        to="/foreigners"
        class="tw-mb-3 sm:tw-mb-0"
      >
        <i-button-icon-text
          icon="icon-angle-left"
          size="medium"
        >
          {{ $t('foreigners.back_to_foreigners') }}
        </i-button-icon-text>
      </router-link>
    </div>

    <div class="tw-mt-10">
      <div class="tw-flex tw-items-center tw-flex-col sm:tw-flex-row">
        <i-user-avatar
          :avatar="foreigner.avatar_url && foreigner.avatar_url['128'] && `${$baseHost}/${foreigner.avatar_url['128']}`"
          :fullname="fullname"
          size="large"
          :status="foreigner.status"
          class="tw-mb-2 sm:tw-mb-0 sm:tw-mr-4"
          is-editable
          @click="$refs.avatarFile.click()"
        />
        <input
          ref="avatarFile"
          accept="image/*"
          class="tw-hidden"
          type="file"
          @change="uploadAvatar($event.target.files[0])"
        >
        <div class="tw-mb-4 sm:tw-mb-0">
          <div class="tw-flex tw-items-center">
            <h2 class="tw-tracking-wider">
              {{ fullname }}
            </h2>
            <ForeignerFamilyPopoverList
              v-if="foreigner.family.length"
              :family="foreigner.family"
              :foreigner-id="foreigner.id"
              store-path="v2/admin/messaging"
            >
              <button class="tw-text-h2 tw-text-primary dark:tw-text-dm-primary tw-ml-2 tw-flex tw-items-center">
                +{{ foreigner.family.length }}
                <icon-angle-down
                  class="tw-ml-1"
                />
              </button>
            </ForeignerFamilyPopoverList>
          </div>
          <div class="tw-leading-5 tw-tracking-normal">
            {{ foreigner.profile.client_company }}
          </div>
        </div>
        <div class="sm:tw-ml-12 md:tw-ml-20 tw-flex tw-items-center">
          <i-user-avatar
            :avatar="foreigner.profile.assigned_to_avatar_url['128'] && `${$baseHost}/${foreigner.profile.assigned_to_avatar_url['128']}`"
            :fullname="foreigner.profile.assigned_to"
            size="small"
            class="tw-mr-3"
          />
          <div class="tw-tracking-normal">
            <div class="tw-text-gray-dark dark:tw-text-dm-gray-dark">
              {{ $t('foreigners.basic_info.assigned_to') }}
            </div>
            <div
              class="tw-text-primary dark:tw-text-dm-primary"
            >
              {{ foreigner.profile.assigned_to }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-tabs
      :model-value="tab"
      class="tw-mt-8"
      @tab-click="handleTabChange"
    >
      <el-tab-pane
        :label="$t('foreigners.tabs.basic_info')"
        name="info"
      />
      <el-tab-pane
        :label="$t('foreigners.tabs.permits')"
        name="permits"
      />
      <el-tab-pane
        :label="$t('foreigners.tabs.questionnaires')"
        name="questionnaires"
      />
      <el-tab-pane
        v-if="$isInRole(['ADMIN', 'CONSULTANT'])"
        :label="$t('foreigners.tabs.log')"
        name="logs"
      />
    </el-tabs>
  </header>
</template>

<script>
import _get from 'lodash/get';

import ForeignerFamilyPopoverList from '@/components/Foreigner/ForeignerFamilyPopoverList.vue';
import { mapState } from 'vuex';

export default {
  components: {
    ForeignerFamilyPopoverList,
  },

  props: {
    tab: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState({
      foreigner: (state) => state.v2.admin.foreigners.foreigner.foreigner,
    }),
    fullname() {
      return `${this.foreigner.first_name} ${this.foreigner.last_name}`;
    },
  },

  methods: {
    handleTabChange(tab) {
      this.$emit('change-tab', tab.props.name);
    },
    async uploadAvatar(file) {
      try {
        const response = await this.$store.dispatch('v2/admin/foreigners/foreigner/uploadAvatar', {
          id: this.foreigner.id,
          avatar: { file },
        });

        this.$message.success({
          message: this.$capitalize(_get(response, 'data.message') || 'Success'),
          showClose: true,
        });

        this.$store.dispatch('v2/admin/foreigners/foreigner/loadForeignerDetail', this.foreigner.id);
      } catch (error) {
        this.$message.error({
          message: this.$capitalize(_get(error, 'response.data.data.avatar_url') || 'Error'),
          showClose: true,
        });
      }
    },
  },
};
</script>
